document.addEventListener('DOMContentLoaded', () => {

  // ========================================================
  // 1. INICIALIZACE KNIHOVEN
  // ========================================================

  // Ikony Lucide
  if (typeof lucide !== 'undefined') {
      lucide.createIcons();
  }

  // Plynulý scroll (Lenis)
  if (typeof Lenis !== 'undefined') {
      const lenis = new Lenis({
          duration: 1.2,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          orientation: 'vertical',
          smoothWheel: true,
      });

      function raf(time) {
          lenis.raf(time);
          requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
  } else {
      console.warn('Lenis nebyl načten.');
  }

  // GSAP + ScrollTrigger
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
  } else {
      console.error('GSAP nebyl načten.');
      return;
  }

  // ========================================================
  // 2. COOKIE POPUP
  // ========================================================
  const cookiePopup = document.getElementById('cookie-popup');
  const acceptBtn = document.getElementById('accept-cookies');
  const storageKey = 'robo-drivex-cookies-accepted'; // Обновленный ключ под новый домен

  if (cookiePopup && acceptBtn) {
      if (!localStorage.getItem(storageKey)) {
          setTimeout(() => {
              cookiePopup.classList.add('show');
          }, 2000);
      }

      // Kliknutí na tlačítko "Přijmout"
      acceptBtn.addEventListener('click', () => {
          localStorage.setItem(storageKey, 'true');
          cookiePopup.classList.remove('show');
      });
  }

  // ========================================================
  // 3. MOBILNÍ MENU
  // ========================================================
  const burger = document.querySelector('.header__burger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileLinks = document.querySelectorAll('.mobile-menu__link');
  const mobileFooter = document.querySelector('.mobile-menu__footer');
  let isMenuOpen = false;

  if (mobileFooter) {
      gsap.set(mobileFooter, { y: 20, opacity: 0 });
  }

  if (burger && mobileMenu) {
      burger.addEventListener('click', toggleMenu);
      mobileLinks.forEach(link => {
          link.addEventListener('click', toggleMenu);
      });
  }

  function toggleMenu() {
      isMenuOpen = !isMenuOpen;

      if (isMenuOpen) {
          mobileMenu.classList.add('is-open');
          document.body.style.overflow = 'hidden';

          gsap.to(mobileLinks, {
              y: 0,
              opacity: 1,
              duration: 0.5,
              stagger: 0.1,
              delay: 0.2,
              ease: 'power2.out'
          });

          if (mobileFooter) {
              gsap.to(mobileFooter, {
                  y: 0,
                  opacity: 1,
                  duration: 0.5,
                  delay: 0.6,
                  ease: 'power2.out'
              });
          }

      } else {
          mobileMenu.classList.remove('is-open');
          document.body.style.overflow = '';
          gsap.to(mobileLinks, { y: 20, opacity: 0, duration: 0.3 });
          if (mobileFooter) {
              gsap.to(mobileFooter, { y: 20, opacity: 0, duration: 0.3 });
          }
      }
  }

  // ========================================================
  // 4. ANIMACE SEKCÍ
  // ========================================================

  // Hero
  const heroTl = gsap.timeline();
  heroTl.from('.hero__title', { y: 50, opacity: 0, duration: 1, ease: 'power3.out' })
        .from('.hero__desc', { y: 30, opacity: 0, duration: 0.8 }, '-=0.6')
        .from('.hero__btns', { y: 20, opacity: 0, duration: 0.8 }, '-=0.6')
        .from('.hero__image-wrapper', { scale: 0.9, opacity: 0, duration: 1 }, '-=0.8');

  gsap.to('.hero__img', {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
          trigger: '.hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true
      }
  });

  // Логика анимации остальных секций (About, Benefits, Blog) остается прежней
  const animateOnScroll = (elements, trigger) => {
    if (elements.length > 0) {
        elements.forEach((el, index) => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top 80%',
                },
                y: 30,
                opacity: 0,
                duration: 0.8,
                delay: index * 0.2,
                ease: 'power2.out',
                clearProps: 'all'
            });
        });
    }
  };

  animateOnScroll(document.querySelectorAll('.about__card'), '.about__grid');
  animateOnScroll(document.querySelectorAll('.benefit-item'), '.benefits__list');
  animateOnScroll(document.querySelectorAll('.blog-card'), '.blog__grid');

  // Innovation (Numbers)
  const statNumbers = document.querySelectorAll('.stat-num');
  statNumbers.forEach(stat => {
      const targetValue = +stat.getAttribute('data-val');
      let proxy = { value: 0 };
      gsap.to(proxy, {
          value: targetValue,
          duration: 2,
          scrollTrigger: {
              trigger: '.innovation',
              start: 'top 80%',
          },
          onUpdate: function() {
              stat.innerText = Math.ceil(proxy.value);
          },
          ease: 'power1.inOut'
      });
  });

  // ========================================================
  // 5. FORMULÁŘ (Контактная форма)
  // ========================================================
  const form = document.getElementById('consultation-form');
  const captchaLabel = document.getElementById('captcha-label');
  const captchaInput = document.getElementById('captcha');

  let num1 = Math.floor(Math.random() * 10);
  let num2 = Math.floor(Math.random() * 10);

  if(captchaLabel) captchaLabel.textContent = `Kolik je ${num1} + ${num2}?`;

  if (form) {
      form.addEventListener('submit', function(e) {
          e.preventDefault();
          let isValid = true;
          document.querySelectorAll('.form-group').forEach(el => el.classList.remove('error'));

          const name = document.getElementById('name');
          if (!name.value.trim()) { setError(name); isValid = false; }

          const email = document.getElementById('email');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { setError(email); isValid = false; }

          const phone = document.getElementById('phone');
          if (!/^[0-9+ ]{6,}$/.test(phone.value)) { setError(phone); isValid = false; }

          if (parseInt(captchaInput.value) !== (num1 + num2)) { setError(captchaInput); isValid = false; }

          const policy = document.getElementById('policy');
          if (!policy.checked) {
              alert('Je nutný souhlas se zpracováním údajů.');
              isValid = false;
          }

          if (isValid) {
              const btn = form.querySelector('button');
              const btnText = btn.textContent;
              btn.textContent = 'Čekejte prosím...'; // "Пожалуйста, подождите"
              btn.disabled = true;

              setTimeout(() => {
                  form.reset();
                  btn.style.display = 'none';
                  const successMsg = document.querySelector('.form-success');
                  if(successMsg) successMsg.style.display = 'block';

                  num1 = Math.floor(Math.random() * 10);
                  num2 = Math.floor(Math.random() * 10);
                  if(captchaLabel) captchaLabel.textContent = `Kolik je ${num1} + ${num2}?`;

                  setTimeout(() => {
                      if(successMsg) successMsg.style.display = 'none';
                      btn.style.display = 'inline-flex';
                      btn.disabled = false;
                      btn.textContent = btnText;
                  }, 5000);
              }, 1500);
          }
      });
  }

  function setError(input) {
      if(input && input.parentElement) input.parentElement.classList.add('error');
  }
});